import go4itLogoLight from '@/assets/go4it-logo-light.png?w=400&format=webp';

// Use optimized import for dark logo too
import go4itLogoDark from '@/assets/go4it-logo.png?w=200&format=webp';
const go4itLogo = go4itLogoDark;

// --- ASSETS & CONFIG ---
export const LOGO_DARK = go4itLogo;
export const LOGO_LIGHT = go4itLogoLight;

// --- STATIC DATA ---
export const NAV_LINKS = [
  { name: 'Home', path: '/' },
  { name: 'Eventbau', path: '/eventbau' },
  { name: 'Aktivierung', path: '/aktivierung' },
  { name: 'Werbetechnik', path: '/werbetechnik' },
  { name: 'Items', path: '/posm' },
];

export const WORK_LINKS = [
  { name: 'Eventbau & Logistik', path: '/eventbau' },
  { name: 'Aktivierung & Promotion', path: '/aktivierung' },
  { name: 'Werbetechnik', path: '/werbetechnik' },
  { name: 'Promotional Items', path: '/posm' },
];

// Team data without images - images are imported in About.tsx to avoid
// bundling ~6 large photos in the initial chunk (only needed on /about)
export const TEAM_DATA = [
  { name: "Mike", role: "Managing Director", aka: "Zirkusdirektor" },
  { name: "Lukas", role: "Junior Project Manager Bar Activation", aka: "Smooth Operator" },
  { name: "Josey", role: "Project Manager Event & POSM", aka: "Singvogel" },
  { name: "Yara", role: "Project Manager Interior Design", aka: "Nasen-Akrobatin" },
  { name: "Vincent", role: "Trainee Project Management", aka: "Bambino" },
  { name: "Olivier", role: "Team Leader Production", aka: "Farb- & Holzkünstler" },
];

export const FRIEND_LOGOS = [
  "Red Bull", "Aperol", "Campari", "Migros Bank", "Absolut", "Jameson",
  "Havana Club", "Nespresso", "Fever-Tree", "PostFinance", "Martini",
  "Grey Goose", "Macallan", "Suze", "Patron", "Lillet", "Sarti", "Appleton"
];
